<template>
  <section id="questionTop" class="question">
    <div class=" qa-wrapper pdt-16">
      <div class="q-wrapper">
        <div class="d-flex pdb-16">
          <div class="t-subtitle2 font-b t-nowrap">Q{{ numberValue }}.</div>
          <div class="flex-grow-1 pdl-4 d-flex align-items-baseline">
            <span class="t-body1 font-r  l-spacing42">{{ checkListData.contents }}</span>
            <span
                class="t-body3 t-color-bodyGrayA  pdl-2 l-spacing42">{{ $t('3380', {str: checkListData.score}) }}</span>
          </div>
        </div>
      </div>
      <div v-if="checkListData.singleChoice.choiceList.length > 0" class="pdl-16 pdr-16">
        <div v-for="(choice, innerIndex) in checkListData.singleChoice.choiceList" :key="innerIndex" class="t-helper">
          <div class="mdc-form-field mgr-24 mgt-12">
            <div class="mdc-radio mdc--radio__custom">
              <input :id="'radio-'+choice.id" v-model="form.selected[innerIndex]"
                     :name="'radio-'+choice.id"
                     :value="true"
                     class="mdc-radio__native-control"
                     type="radio"
                     @change="onSelectData($event, innerIndex, checkListData.singleChoice.choiceList.length)">
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
              <div class="mdc-radio__ripple"></div>
            </div>
            <label :for="'radio-'+choice.id" class="t-body1 font-r min-w-47 pdb-4">{{ choice.contents }}
              <span
                  class="t-body3 t-color-bodyGrayA  pdl-2 l-spacing42 font-r">{{
                  $t('3380', {str: choice.score})
                }}</span></label>
          </div>
        </div>
      </div>
      <div v-if="validField" class="d-flex pdl-6 align-items-center">
        <i class="material-icons t-color-secondaryBtnText font-18" role="button" tabindex="0">report_problem</i>
        <div class="mdc-text-field-helper-line pdl-4">
          <div
              id="my-helper-id"
              aria-hidden="true"
              class="mdc-text-field-helper-text t-color-secondaryBtnText t-helper font-r opacity-1 l-spacing36 t-line-h-20 mdc-text-field-helper-text--validation-msg">
            {{ $t('3388') }}
          </div>
        </div>
      </div>
      <photo-album :documentshow="documentshow" :form="form" :numberValue="numberValue"
                   @removeImage="removeImage" @toggleDocument="toggleDocument"
                   @uploadFile="uploadFile"></photo-album>
    </div>
  </section>
</template>

<script>
/**
 * 단일답안 문항 컴포넌트(choice single type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield';
import {questionMixin} from '@/mixins/question.js'
import {fileMixin} from "@/mixins/file";

export default {
  props: ['numberValue', 'checkListData', 'form', 'validField'],

  data() {
    return {
      selected: [],
      isSolve: false,
      formula: '$$x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.$$',
      documentshow: false,
      imageshow: false,
      uploadTypeImg: false
    }
  },

  components: {
    'photo-album': () => import('@/components/common/ChecklistPhotoAlbum'),
  },

  mixins: [questionMixin, fileMixin],

  mounted() {
    this.filterTextArea();
  },

  methods: {
    filterTextArea() {
      setTimeout(() => {
        const textField = new MDCTextField(document.querySelector('.single-text-area'))
      }, 100)
    },

    onSelectData($event, index, totalLength) {
      this.form["selected"] = [];
      for (let i = 0; i < totalLength; i++) {
        if (index == i) {
          this.form["selected"].push($event.target.checked);
          this.validField = false;
        } else {
          this.form["selected"].push(false);
        }
      }
    },
  }
}
</script>
